export default __webpack_public_path__ + "static/media/smol-show.8bb99123.avif";